import './Title.css';

function MailLink(props) {
  const {
    name,
    email,
  } = props;
  return (
    <a href={`mailto:${email}`}>{name}</a>
  );
}

function Title() {
  return (
    <div className="title">
        <a
          className="title__paper"
          href="https://www.airitilibrary.com/Publication/alDetailedMesh1?DocID=U0001-1107202111044100">
          Unsupervised WaveNet-based Singing Voice Conversion Using Pitch Augmentation and Two-phase Approach
        </a>
      <div className="title__authors">
        <MailLink name="Song-Rong Lee" email="hubert.srlee@gmail.com"/>{', '}
        <MailLink name="Chung-Che Wang" email="geniusturtle@mirlab.org"/>{', '}
        <MailLink name="Jyh-Shing Jang" email="roger.jang@gmail.com"/>
      </div>
      <a href="http://mirlab.org/" className="title__lab">
        National Taiwan University, Multimedia Information Retrival Lab
      </a>
    </div>
  );
}

export default Title;
